<div class="container mb-5">
        <div class="row">
          <div class="col-sm-2">
            <ul class="list-group navBack">
              <a href="/moncompte"><li  class="list-group-item " [ngClass]="{'active': this.pageName == 'commandes'}"><i class="fa fa-shopping-basket" aria-hidden="true"></i>
            Mes commandes</li></a>
              <a href="javascript:void(0);" (click)="logout()" ><li class="list-group-item logout"><i class="fa fa-sign-out" aria-hidden="true"></i> Déconnexion</li></a>
            </ul>
          </div>
          <div class="col-sm-10">
            <div class="card p-3">
              <table id="tableBalance" class="table table-striped" style="width:100%">
                <thead>
                    <tr>
                        <th>Num commande</th>
                        <th>Date commande</th>
                        <th>Montant HT</th>
                        <th>Montant TTC</th>
                        <th>Nombre d'article</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let commande of listCommandes">
                        <td>{{commande.ref}}</td>
                        <td>{{commande.dateAt }}</td>
                        <td>{{commande.montant_ht}}</td>
                        <td>{{commande.montant_ttc}}</td>
                        <td>{{commande.nbr}}</td>
                        <td width="20%">
                          <a [routerLink]="['/commandeDetail', commande.ref]" >
                            <button class="btn btn-detail" type="button" name="button" style="width:100%; margin-bottom:2px;"><i class="fa fa-eye"></i> Détail</button>
                          </a>
                        </td>
                    </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
